export default __webpack_public_path__ + "static/media/smooth-impact.5174afda.png";